export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Panoramica piattaforma aperta',
  'pages.openapi.overview.loadFailed': 'Impossibile caricare il riepilogo utilizzo (API forse non pronta)',
  'pages.openapi.overview.docsTitle': 'Guida all\'integrazione',
  'pages.openapi.overview.docsDesc':
    'BasePath della piattaforma aperta: /v1. Busta di risposta: {code,message,data,request_id}. Per le API Key inviare Authorization: Bearer sk_live_... / sk_test_.... La chiave in chiaro viene mostrata solo una volta in creazione o rotazione—conservala in sicurezza.',
  'pages.openapi.overview.level': 'Livello attuale',
  'pages.openapi.overview.qps': 'Limite QPS',
  'pages.openapi.overview.apps': 'App',
  'pages.openapi.overview.appsSuffix': '(max {maxApps}, chiavi per app {maxKeys})',
  'pages.openapi.status.active': 'Attivo',
  'pages.openapi.status.disabled': 'Disattivato',
  'pages.openapi.apps.title': 'App e chiavi',
  'pages.openapi.apps.listTitle': 'Le mie app',
  'pages.openapi.apps.create': 'Crea app',
  'pages.openapi.apps.createModal': 'Crea app',
  'pages.openapi.apps.name': 'Nome app',
  'pages.openapi.apps.nameRequired': 'Inserisci un nome',
  'pages.openapi.apps.description': 'Descrizione',
  'pages.openapi.apps.status': 'Stato',
  'pages.openapi.apps.createdAt': 'Creato il',
  'pages.openapi.apps.createSuccess': 'App creata',
  'pages.openapi.apps.createFailed': 'Creazione app non riuscita',
  'pages.openapi.apps.loadFailed': 'Caricamento app non riuscito',
  'pages.openapi.apps.keysLoadFailed': 'Caricamento chiavi non riuscito',
  'pages.openapi.apps.delete': 'Elimina',
  'pages.openapi.apps.deleteConfirm': 'Eliminare questa app?',
  'pages.openapi.apps.deleted': 'Eliminata',
  'pages.openapi.apps.createKey': 'Crea Key',
  'pages.openapi.apps.createKeyModal': 'Crea API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Chiave creata',
  'pages.openapi.apps.keyCreateFailed': 'Creazione chiave non riuscita',
  'pages.openapi.apps.noPlainKey': 'Nessuna chiave in chiaro restituita',
  'pages.openapi.apps.plainKeyTitle': 'Salva la tua API Key',
  'pages.openapi.apps.plainKeyHint': 'Il testo in chiaro viene mostrato solo una volta e non sarà più visibile dopo la chiusura.',
  'pages.openapi.apps.copy': 'Copia',
  'pages.openapi.apps.copied': 'Copiato',
  'pages.openapi.apps.copyFailed': 'Copia non riuscita; seleziona manualmente',
  'pages.openapi.apps.close': 'Chiudi',
  'pages.openapi.apps.key.name': 'Nome',
  'pages.openapi.apps.key.namePlaceholder': 'Chiave principale di produzione',
  'pages.openapi.apps.key.prefix': 'Prefisso',
  'pages.openapi.apps.key.env': 'Ambiente',
  'pages.openapi.apps.key.status': 'Stato',
  'pages.openapi.apps.key.createdAt': 'Creato il',
  'pages.openapi.apps.key.disable': 'Disattiva',
  'pages.openapi.apps.key.disableConfirm': 'Disattivare questa chiave?',
  'pages.openapi.apps.key.disabled': 'Disattivata',
  'pages.openapi.apps.key.enable': 'Attiva',
  'pages.openapi.apps.key.enabled': 'Attivata',
  'pages.openapi.apps.key.rotate': 'Ruota',
  'pages.openapi.apps.key.rotateConfirm': 'La rotazione genera una nuova chiave e restituisce il chiaro una sola volta. Continuare?',
  'pages.openapi.apps.key.rotated': 'Ruotata',
  'pages.openapi.apps.key.delete': 'Elimina',
  'pages.openapi.apps.key.deleteConfirm': 'Eliminare questa chiave? Operazione irreversibile.',
  'pages.openapi.apps.key.deleted': 'Eliminata',
  'pages.openapi.logs.title': 'Log di utilizzo',
  'pages.openapi.logs.listTitle': 'Dettagli chiamate',
  'pages.openapi.logs.dailyTitle': 'Utilizzo ultimi 14 giorni',
  'pages.openapi.logs.dailyEmpty': 'Nessun dato di utilizzo giornaliero',
  'pages.openapi.logs.date': 'Data',
  'pages.openapi.logs.count': 'Chiamate',
  'pages.openapi.logs.createdAt': 'Ora',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Incolla il request_id dalla risposta API',
  'pages.openapi.logs.detail': 'Dettagli',
  'pages.openapi.logs.detailTitle': 'Dettagli chiamata',
  'pages.openapi.logs.detailLoading': 'Caricamento…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Richiesta',
  'pages.openapi.logs.responseBody': 'Risposta',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'ID app',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID utente',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Prefisso Key',
  'pages.openapi.logs.method': 'Metodo',
  'pages.openapi.logs.path': 'Percorso',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Codice business',
  'pages.openapi.logs.latency': 'Latenza (ms)',
  'pages.openapi.logs.loadFailed': 'Caricamento non riuscito',
  'pages.openapi.planTiers.title': 'Piani piattaforma aperta',
  'pages.openapi.planTiers.level': 'Livello',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Nome',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Quota giornaliera',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Max app',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Max chiavi per app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Salva',
  'pages.openapi.planTiers.saved': 'Salvato',
  'pages.openapi.planTiers.saveFailed': 'Salvataggio non riuscito',
  'pages.openapi.planTiers.loadFailed': 'Caricamento piani non riuscito',
  'pages.openapi.planTiers.readonly': 'Gli osservatori sono in sola lettura e non possono modificare i piani',
  'pages.openapi.admin.usageLogsTitle': 'Audit chiamate piattaforma aperta',
  'pages.openapi.admin.usageLogsList': 'Log chiamate globali',
  'pages.openapi.admin.disableKeyConfirm': 'Disattivare questa API Key?',
  'pages.openapi.admin.disableKey': 'Disattiva Key',
  'pages.openapi.admin.keyDisabled': 'Disattivata',
  'pages.openapi.admin.appsTitle': 'App piattaforma aperta',
  'pages.openapi.admin.appsList': 'Tutte le app sviluppatore',
  'pages.openapi.admin.developers': 'Sviluppatori',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Chiavi totali',
  'pages.openapi.admin.activeKeys': 'Chiavi attive',
  'pages.openapi.admin.todayRequests': 'Chiamate di oggi',
  'pages.openapi.admin.todayErrors': 'Errori di oggi',
  'pages.openapi.admin.errorCount': 'Errori',
  'pages.openapi.admin.owner': 'Proprietario',
  'pages.openapi.admin.keyCount': 'Chiavi',
  'pages.openapi.admin.keyword': 'Parola chiave',
  'pages.openapi.admin.keywordPlaceholder': 'Nome app / descrizione / codice tenant',
  'pages.openapi.admin.statsLoadFailed': 'Caricamento statistiche non riuscito',
  'pages.openapi.admin.noKeys': 'Nessuna chiave',
  'pages.openapi.admin.appEnabled': 'App attivata',
  'pages.openapi.admin.appDisabled': 'App disattivata',
  'pages.openapi.admin.appDisableConfirm': 'Disattivare questa app?',
  'pages.openapi.admin.appEnableConfirm': 'Attivare questa app?',
  'pages.openapi.admin.keyEnableConfirm': 'Attivare questa chiave?',
  'pages.admin.user.openapiDeveloperEnabled': 'Piattaforma aperta',
  'pages.admin.user.openapi.on': 'Attivato',
  'pages.admin.user.openapi.off': 'Disattivato',
  'pages.admin.user.openapiLevel': 'Livello piattaforma aperta',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Attiva sviluppatore',
  'pages.admin.user.openapiLevel.label': 'Livello',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Utilizzo di oggi',
  'pages.openapi.apps.key.enableConfirm': 'Attivare questa chiave?',
  'pages.admin.user.section.openapi': 'Piattaforma aperta',
};
